// 过万数字处理
const displayNum = (num) => {
  if (!num) {
    return num;
  }
  let str = num + "";
  if (num > 9999) {
    const val = num / 10000;
    if (num % 10000 === 0) {
      str = num / 10000 + "w";
    } else {
      const fixedNum = Math.floor(val * 10) / 10;
      str = fixedNum + (val === fixedNum ? "w" : "w+");
    }
  }
  return str;
};

// 过千数字处理
export const displayThousandNum = (num) => {
  if (!num) {
    return num;
  }
  let str = num + "";
  if (num > 999) {
    const val = num / 1000;
    if (num % 1000 === 0) {
      str = num / 1000 + "k";
    } else {
      str = val.toFixed(1) + "k";
    }
  }
  return str;
};

export default displayNum;
